import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { FaSearch, FaTimes } from 'react-icons/fa';
import './ModifierSearchSection.scss';

interface ModifierSearchSectionProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const ModifierSearchSection: React.FC<ModifierSearchSectionProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <div className="modifier-search-section-clean">
      <Form.Group>
        <InputGroup className="search-input-group-clean">
          <InputGroup.Text className="search-icon-container-clean">
            <FaSearch className="search-icon-clean" />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Buscar modificadores por nombre o descripción..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input-clean"
          />
          {searchTerm && (
            <InputGroup.Text 
              className="clear-icon-container-clean"
              onClick={() => setSearchTerm('')}
            >
              <FaTimes className="clear-icon-clean" />
            </InputGroup.Text>
          )}
        </InputGroup>
      </Form.Group>
    </div>
  );
};

export default ModifierSearchSection;
